"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Get the extension of the file name
*/
function extension(string) {
    var regex = /(?:\.([^.]+))?$/, extension = regex.exec(string);
    return extension ? extension[1] : '';
}
exports.default = extension;
;
//# sourceMappingURL=extension.js.map